import { Fragment, h } from 'preact';
import RedirectElement from '../Redirect';
import RedirectButton from '../internal/RedirectButton';
import { TxVariants } from '../tx-variants';
import './Trustly.scss';

class TrustlyElement extends RedirectElement {
    public static override readonly type: TxVariants = TxVariants.trustly;

    override get displayName() {
        return this.props.name || this.constructor['type'];
    }

    protected override componentToRender(): h.JSX.Element {
        return (
            <Fragment>
                <div className="adyen-checkout-trustly">
                    <p className="adyen-checkout-trustly__descriptor">{this.props.i18n.get('trustly.descriptor')}</p>
                    <ul className="adyen-checkout-trustly__description-list">
                        <li>{this.props.i18n.get('trustly.description1')}</li>
                        <li>{this.props.i18n.get('trustly.description2')}</li>
                    </ul>
                </div>

                <RedirectButton
                    {...this.props}
                    name={this.displayName}
                    onSubmit={this.submit}
                    payButton={this.payButton}
                    setComponentRef={this.setComponentRef}
                />
            </Fragment>
        );
    }
}

export default TrustlyElement;
